module.exports = __webpack_public_path__ + "img/stena03.9a04c9a5.jpg";